export const Scope = {
  ALL: 'all',
  CATEGORIES: 'categories',
  PRODUCTS: 'products',
} as const;

export type ScopeType = typeof Scope[keyof typeof Scope];
